export default "__VITE_ASSET__CzGUo5y4__"